import React from "react";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { theme } from "antd";

const MetricBox = (props) => {
  const { token } = theme.useToken();
  const hexToRgb = (hex) => {
    hex = hex.replace(/^#/, "");
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    return `${r}, ${g}, ${b}`;
  };

  const isPopPositive = props.popValue > 0;
  const isInverted = props.isInverted;

  var color = null;
  var textColor = null;
  const root = getComputedStyle(document.documentElement);
  const opacity = 0.5;

  if (isInverted) {
    if (isPopPositive) {
      color = root.getPropertyValue("--red-color").trim();
      color = hexToRgb(color);
      color = `rgba(${color}, ${opacity})`;

      textColor = "var(--primary-color)";
    }
    if (!isPopPositive) {
      color = root.getPropertyValue("--green-color").trim();
      color = hexToRgb(color);
      color = `rgba(${color}, ${opacity})`;

      textColor = "var(--primary-color)";
    }
  } else {
    if (isPopPositive) {
      color = root.getPropertyValue("--green-color").trim();
      color = hexToRgb(color);
      color = `rgba(${color}, ${opacity})`;

      textColor = "var(--primary-color)";
    }
    if (!isPopPositive) {
      color = root.getPropertyValue("--red-color").trim();
      color = hexToRgb(color);
      color = `rgba(${color}, ${opacity})`;
      textColor = "var(--primary-color)";
    }
  }

  const boxMetricType = props.boxMetricType;
  console.log("content_type in box metric", props.boxMetricType);

  return (
    <div
      className="soft-shadow"
      style={{
        backgroundColor: "var(--tertiary-color)",
        animation: "fadeIn 1.5s",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "100%",
        minHeight: "148px",
        height: "100%",
        padding: "28px",
        borderRadius: token.cardRadius,
        overflow: "hidden",
        // gap: boxMetricType === "box_metric_long" ? "0px" : "1.5rem",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          width: "100%",
          marginTop: "0",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <p
          style={{
            fontSize: "1.1em",
            fontWeight: "600",
            fontFamily: "var(--co-font-primary)",
            // maxWidth: "10vw",
            marginBottom: "0",
            width: "100%",
            textAlign: "center",
            // backgroundColor: "red",
          }}
        >
          {props.title}
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "24px",
            width: "100%",
          }}
        >
          {props.popValue !== null &&
            props.popValue !== undefined &&
            !isNaN(props.popValue) &&
            props.popValue !== 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: color,
                  borderRadius: "6px",
                  padding: "0.3rem 0.4rem",
                  fontSize: "0.82em",
                  fontWeight: "600",
                  minWidth: "4vw",
                  width: "100%",
                  maxHeight: "24px",
                  textAlign: "center",
                  alignContent: "center",
                  color: textColor,
                  gap: "8px",
                }}
              >
                {isPopPositive ? <CaretUpOutlined /> : <CaretDownOutlined />}
                {props.popValue}%
              </div>
            )}
          {props.boxMetricType === "box_metric_long" && (
            <p
              style={{
                fontSize: props.value === "No Data Available" ? "1.4em" : "2.2em",
                width: "100%",
                color: props.value === "No Data Available" ? "var(--medium-light-grey-color)" : "inherit",
                fontWeight: "bold",
                fontFamily: "var(--co-font-primary)",
                alignContent: "center",
                marginBottom: "0px",
              }}
            >
              {props.value}
            </p>
          )}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignSelf: "center",
        }}
      >
        {props.boxMetricType !== "box_metric_long" && (
          <p
            style={{
              fontSize: props.value === "No Data Available" ? "1.4em" : "1.6em",
              width: "100%",
              fontWeight: "bold",
              fontFamily: "var(--co-font-primary)",
              alignContent: "center",
              marginBottom: "0px",
              textAlign: "center",
              boxSizing: "border-box",
              color: props.value === "No Data Available" ? "var(--medium-light-grey-color)" : "inherit",
            }}
          >
            {props.value}
          </p>
        )}
      </div>
    </div>
  );
};

export default MetricBox;
